import { render, staticRenderFns } from "./FiltersSummary.vue?vue&type=template&id=5b4a276d&"
import script from "./FiltersSummary.vue?vue&type=script&lang=js&"
export * from "./FiltersSummary.vue?vue&type=script&lang=js&"
import style0 from "./FiltersSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports